<template>
  <div class="config_main_manage_background">
    <!-- 设置页面的内容区域 -->
    <div class="config_main_manage_page_wraper">
      <div class="config_main_manage_page_content">
        <!-- 设置页面  内容区域样式   以上部分都是公共样式 -->
        <config-title-hang>
          <span slot="config_title_hang_ele2">循环次数选择</span>
        </config-title-hang>

        <!-- 可选的循环次数列表 -->
        <config-hang
          v-for="(value , index) in loopListData"
          :key="index"
          @click.native="selectObjectBtnHandle(value)"
          :selectState="selectObjectID === value.id"
        >
          <span slot="config_hang_ele2">{{value.name}}</span>
          <img slot="config_hang_weixuan" src="~assets/img/config/weixuan.png" alt />
          <img slot="config_hang_xuanzhong" src="~assets/img/config/xuanzhong.png" alt />
        </config-hang>

        <div class="public_config_que_ren_btn" @click="saveReturnBtnHandle">保存并返回</div>
      </div>
    </div>
  </div>
</template>

<script>
import topNav from 'components/common/topnav/topnav'
import topNavItem from 'components/common/topnav/topnavitem'
import configHang from 'components/common/config/config-hang'
import configTitleHang from 'components/common/config/config-title-hang'
// import { mediumslateblue } from "color-name";
import { configPageDataRequest } from 'views/afterLogin/config/deviceManagePage/deviceListPage/public_config_requery_js'

export default {
  data() {
    return {
      loopListData: [
        ///循环次数列表数据
        {
          id: 0,
          name: '永久'
        },
        {
          id: 1,
          name: '1次'
        },
        {
          id: 2,
          name: '2次'
        },
        {
          id: 3,
          name: '3次'
        },
        {
          id: 4,
          name: '4次'
        },
        {
          id: 5,
          name: '5次'
        },
        {
          id: 6,
          name: '6次'
        }
      ],
      selectObjectID: '', ///当前选中的对象ID
      serveOneLoopTask027Data: {
        ///循环定时信息
      }
      // businessIdDesc:"",//////当前选中的对象回显name
      // ServeOneObjectinfo: {
      //   ////地址指向仓库  当前要进行设置对象的信息
      // }
    }
  },
  components: {
    topNav,
    topNavItem,
    configHang,
    configTitleHang
  },
  methods: {
    selectObjectBtnHandle(value) {
      // console.log("111111");
      this.selectObjectID = value.id
      // this.businessIdDesc = value.regionName + '(' + value.remark + ')'
    },
    saveReturnBtnHandle() {
      ///保存并返回按钮点击了
      if (this.selectObjectID === '') {
        this.$toast('请至少选择一个循环次数！')
        return
      }
      this.serveOneLoopTask027Data.loopNum = this.selectObjectID
      // console.log(this.$route.query.serveOneLoopTask027Data.loopNum)
      this.$router.go(-1)
    }
  },
  created() {
    console.log('created阶段')
    this.serveOneLoopTask027Data = this.$store.state.configinfo.serveOneLoopTask027Data ////循环定时信息拿过来
    this.selectObjectID = this.serveOneLoopTask027Data.loopNum
  }
}
</script>

<style>
</style>